/**
 *  Minimum required score for victory
 */
export const WINNING_SCORE = 30;

/**
 *  Minimum lost hatchlings for defeat
 */
export const LOSING_SCORE = 15;
